import  "./Tournaments.css"
import RoadMapItem from './RoadMapItem';
import { roadmapData } from './RoadmapData';
import SiteHeader from "./../../components/SiteHeader";

const Tournaments = () => {      
  return (
    <>
    <div class="bodyContainer">
        <SiteHeader current="tournaments"></SiteHeader>
        <div class="homeContainer mt-5">
            <div className="container" >
                <section className="roadmap">
                    <div className="roadmap__timeline">
                    {roadmapData.map((item, index) => (
                        <RoadMapItem
                        key={item.id}
                        id={item.id}
                        stage={item.stage}
                        details={item.details}
                        isEven={index % 2 === 0}
                        img={item.img}
                        />
                    ))}
                    </div>
                </section>
            </div>
            {/* <footer class="bg-body-tertiary text-center text-lg-start">
                <div class="container p-4">
                <div class="row">
                <div class="col-lg-6 col-md-12 mb-4 mb-md-0">
                    <h5 class="text-uppercase">Footer text</h5>

                    <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste atque ea quis
                    molestias. Fugiat pariatur maxime quis culpa corporis vitae repudiandae aliquam
                    voluptatem veniam, est atque cumque eum delectus sint!
                    </p>
                </div>
                <div class="col-lg-6 col-md-12 mb-4 mb-md-0">
                    <h5 class="text-uppercase">Footer text</h5>

                    <p>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste atque ea quis
                    molestias. Fugiat pariatur maxime quis culpa corporis vitae repudiandae aliquam
                    voluptatem veniam, est atque cumque eum delectus sint!
                    </p>
                </div>
                </div>
            </div>
            <div class="text-center p-3">
                © 2020 Copyright:
                <a class="text-body" href="https://mdbootstrap.com/">MDBootstrap.com</a>
            </div>
        </footer> */}
        </div>
    </div>
  </>
  );
};

export default Tournaments;
